export default __webpack_public_path__ + "static/media/mastercard@1,5x.a7c3b3c2.svg";